export const getProductName = (stockItem: any) => {
  if (!stockItem) return "Produit inconnu";
  
  try {
    // Si stockItem est un tableau, prendre le premier élément
    const item = Array.isArray(stockItem) ? stockItem[0] : stockItem;
    
    // Si data est une chaîne JSON, la parser
    const data = typeof item.data === 'string' 
      ? JSON.parse(item.data) 
      : item.data;

    // Vérifier d'abord si le nom est dans data.Nom (format standard)
    if (data.Nom) {
      return data.Nom;
    }
    
    // Sinon, chercher dans data.nom (format alternatif)
    if (data.nom) {
      return data.nom;
    }

    // Si data.name existe, l'utiliser
    if (data.name) {
      return data.name;
    }
    
    // Si aucun nom n'est trouvé, chercher dans d'autres propriétés possibles
    const possibleNameKeys = ['Name', 'NOM', 'product_name', 'productName'];
    for (const key of possibleNameKeys) {
      if (data[key]) {
        return data[key];
      }
    }
    
    // Si aucun nom n'est trouvé, retourner un message explicite
    console.warn("Aucun nom trouvé dans:", data);
    return "Nom du produit non défini";
  } catch (e) {
    console.error("Erreur lors de la lecture du nom du produit:", e, stockItem);
    return "Erreur de lecture du produit";
  }
};